import React from 'react'

import HeaderTopBar from './components/HeaderTopBar/HeaderTopBar.component'
import HeaderNavBar from './components/HeaderNavBar/HeaderNavBar.component'
import Breadcrumbs from './components/Breadcrumbs/Breadcrumbs.components'
import AboutUsHeroSection from './components/AboutUsHeroSection/AboutUsHeroSection.component'
import AboutUsLogoShowcase from './components/AboutUsLogoShowcase/AboutUsLogoShowcase.component'
import OurMission from './components/OurMission/OurMission.component'
import OurGrowingNationalFootprint from './components/OurGrowingNationalFootprint/OurGrowingNationalFootprint.component'
import OfficeLocations from './components/OfficeLocations/OfficeLocations.component'
import OurCompanyHistory from './components/OurCompanyHistory/OurCompanyHistory.component'
import LeadershipAndStory from './components/LeadershipAndStory/LeadershipAndStory.component'
import FooterContent from './components/FooterContent/FooterContent.component'
import FooterDisclaimer from './components/FooterDisclaimer/FooterDisclaimer.component'

import './AboutUs.page.scss'

class AboutUsPage extends React.Component {
  componentDidMount() {
    document.title = 'About Us | Health Insurance Agency | USA Benefits Group'
  }

  render() {
    return (
      <div id='AboutUsPage'>
        <HeaderTopBar />
        <HeaderNavBar />
        <Breadcrumbs
          items={[{ label: 'Home', href: '/' }, { label: 'Why USA Benefits Group' }, { label: 'About Us' }]}
        />
        <AboutUsHeroSection />
        <AboutUsLogoShowcase />
        <OurMission />
        <OurGrowingNationalFootprint />
        <OfficeLocations />
        <OurCompanyHistory />
        <LeadershipAndStory />
        <FooterContent />
        <FooterDisclaimer />
      </div>
    )
  }
}

export default AboutUsPage
